import { gql } from '@apollo/client';

export const CREATE_STANDARD_MUTATOR = gql`
  mutation CreateStandardMutator(
    $master_list: Boolean
    $standards: [JSON]
    $group_id: String
    $company_id: String
    $user_email: String
  ) {
    createStandards(
      master_list: $master_list
      standards: $standards
      group_id: $group_id
      company_id: $company_id
      user_email: $user_email
    )
  }
`;

export const UPDATE_STANDARD_MUTATOR = gql`
  mutation UpdateStandardMutator(
    $master_list: Boolean
    $updated_standard: JSON
    $original_standard: JSON
    $group_id: String
    $company_id: String
    $user_email: String
  ) {
    updateStandard(
      master_list: $master_list
      updated_standard: $updated_standard
      original_standard: $original_standard
      group_id: $group_id
      company_id: $company_id
      user_email: $user_email
    )
  }
`;

export const DELETE_STANDARD_MUTATOR = gql`
  mutation DeleteStandardMutator(
    $group_id: String
    $company_id: String
    $standard_id: String
    $standard_name: String
    $user_email: String
  ) {
    deleteStandard(
      group_id: $group_id
      company_id: $company_id
      standard_id: $standard_id
      standard_name: $standard_name
      user_email: $user_email
    )
  }
`;

export const DELETE_STANDARD_WITH_METRICS_MUTATOR = gql`
  mutation DeleteStandardWithMetricsMutator(
    $master_list: Boolean
    $standard_id: String
    $standard_name: String
    $group_id: String
    $company_id: String
  ) {
    deleteStandardWithMetrics(
      master_list: $master_list
      standard_id: $standard_id
      standard_name: $standard_name
      group_id: $group_id
      company_id: $company_id
    )
  }
`;
